<template>
  <div class="container-desktop-mobile">
    <div class="class-desktop">
      <div class="col-12 flex-container">
        <div class="col-6 p-0">
          <img
            :src="'data:image/png;base64,' + this.pix_base64"
            alt="QRCode"
            id="qr"
            class="justify-center"
          />

          <div class="footer-pix">
            <div class="style-font">
              <span>Você pode pagar com esse QR Code</span><br />
              <span class="span-hour">
                até {{ this.pix_dt_vencto | formatDate }} às
                {{ this.pix_hour_expiration }}
              </span>
            </div>

            <div class="row-6 pix-copy-qr mt-2">
              <button
                type="button"
                id="copyQRCode"
                class="btn pix-copy-qr-btn"
                @click="copy()"
              >
                {{ this.pix_copiado ? "QR Code copiado!" : "Copiar QR Code" }}
              </button>
            </div>
          </div>
        </div>

        <div class="col-8 mt-4 div-pix-data">
          <div class="style-font-info">
            <div class="row row-pix-info">
              <span class="span-pix-info-title">Inscrição cedente:</span>
              <span class="span-pix-info">
                {{ this.ced_inscricao | formatCPFCNPJ }}
              </span>
            </div>
            <div class="row row-pix-info">
              <span class="span-pix-info-title">Cedente:</span>
              <span class="span-pix-info"> {{ this.cedente }}</span>
            </div>
            <div class="row row-pix-info">
              <span class="span-pix-info-title">Inscrição pagador:</span>
              <span class="span-pix-info">
                {{ this.sac_inscricao | formatCPFCNPJ }}</span
              >
            </div>
            <div class="row row-pix-info">
              <span class="span-pix-info-title">Pagador:</span>
              <span class="span-pix-info"> {{ this.sacado }}</span>
            </div>
            <div class="row row-pix-info">
              <span class="span-pix-info-title">Documento:</span>
              <span class="span-pix-info">{{ this.num_docto }}</span>
            </div>
            <div class="row row-pix-info">
              <span class="span-pix-info-title">Nosso número:</span>
              <span class="span-pix-info">{{ this.nosso_numero }}</span>
            </div>
            <div class="row row-pix-info">
              <span class="span-pix-info-title">Vencimento:</span>
              <span class="span-pix-info">
                {{ this.cod_dt_vencto | formatDate }}
              </span>
            </div>
            <div class="row row-pix-info">
              <span class="span-pix-info-title">Valor a pagar:</span>
              <span class="span-pix-info">
                {{ this.pix_valor | formatCurrency }}</span
              >
            </div>
          </div>
          <div class="row style-font mt-4 border-primary">
            <span class="mb-2 mt-2 span-siga-passos">
              Siga os passos:
            </span>
            <br />
            <span
              ><span class="use-qr-code-number">1.</span> Abra o app do seu
              banco;</span
            >
            <span
              ><span class="use-qr-code-number">2.</span> Busque a opção de
              pagamento com QR Code e escaneie o código acima;</span
            >
            <span
              ><span class="use-qr-code-number">3.</span> Revise as informações
              e confirme o pagamento;</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="class-mobile">
      <div v-if="pix_disponivel">
        <div
          class="col-12"
          v-if="!this.pix_base64"
          style="display: flex; justify-content: center"
        >
          <img src="static/img/pix.gif" style="width: 400px" />
        </div>
        <div
          v-else
          class="col-12"
          style="display: flex; margin-top: -55px; padding: 0px"
        >
          <div class="col-6">
            <img
              :src="'data:image/png;base64,' + this.pix_base64"
              alt="QRCode"
              id="qrcode"
            />
            <div
              class="row style-font justify-center style-time-ipad"
              style="margin-left: 10px"
            >
              <span>QR Code válido até</span
              ><span
                >{{ this.pix_dt_vencto | formatDate }} às
                {{ this.pix_hour_expiration }}</span
              >
            </div>
          </div>

          <div class="col-6">
            <div>
              <span
                class="mt-4"
                style="
                      font-size: 20px;
                      display: flex;
                      justify-content: center;
                      color: rgb(100, 95, 95);
                    "
              >
                {{ this.pix_valor | formatCurrency }}</span
              ><br />

              <div class="justify-center">
                <button
                  id="copyQRCodeMobile"
                  type="button"
                  class="btn pix-copy-qr-btn"
                  @click="copy()"
                >
                  Copiar QR Code
                </button>
              </div>
              <div class="style-number-ipad">
                <span
                  style="
                        font-size: 11px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 11ch;
                        color: rgb(100, 95, 95);
                      "
                  >Nosso número: {{ this.nosso_numero }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  name: "PixPassword",
  props: {
    pix_emv: String,
    ced_inscricao: String,
    cedente: String,
    sac_inscricao: String,
    sacado: String,
    num_docto: String,
    nosso_numero: String,
    cod_dt_vencto: Date,
    pix_valor: Number,
    pix_base64: String,
    pix_dt_vencto: Date,
    pix_disponivel: Boolean,
    pix_hour_expiration: String,
  },
  data() {
    return {
      pix_copiado: false,
    };
  },
  methods: {
    copy() {
      var textarea = document.createElement("textarea");
      textarea.textContent = this.pix_emv;
      textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy"); // Security exception may be thrown by some browsers.
      } catch (ex) {
        console.warn("A cópia para a área de transferência falhou.", ex);
        return prompt("Copie o PIX: Ctrl+C, Enter", text);
      } finally {
        document.body.removeChild(textarea);
      }

      Vue.$toast.success("Pix copiado com sucesso!", {
        position: "top-right",
        duration: 3000,
      });

      this.pix_copiado = true;
      setTimeout(() => {
        this.pix_copiado = false;
      }, 2000);
    },
  },
};
</script>
<style scoped>
.span-siga-passos {
  width: 100%;
  color: #898585;
}

.div-pix-data {
  margin-left: -12%;
}

.span-hour {
  margin-left: 30px;
}

.footer-pix {
  margin-left: 17px;
}

#qr {
  width: 250px;
}

.flex-container {
  display: flex;
  margin-top: -55px;
}

.p-0 {
  padding: 0px;
}

.style-font {
  font-size: 13px;
  color: rgb(100, 95, 95);
}

.style-font-info {
  font-size: 16px;
  color: rgb(100, 95, 95);
}

.justify-center {
  display: flex;
  justify-content: center;
}

.pix-copy-qr-btn {
  font-size: 12px;
  color: #fff;
  background-color: #5b3088;
  width: 215px;
}

.span-pix-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30ch;
  font-size: 0.9rem;
  align-self: center;
}

.span-pix-info-title {
  min-width: 160px;
  color: #898585;
}

.use-qr-code-number {
  color: #424242;
}
.class-mobile {
  display: none !important;
}
@media only screen and (max-width: 767px) {
  #qrcode {
    width: 150px;
    margin-left: 30px;
  }

  .class-mobile {
    display: flex !important;
    width: 100%;
    margin: 0 auto;
  }
  .class-desktop {
    display: none !important;
    height: 355px;
  }

  .style-time-ipad {
    padding-left: 0 !important;
  }
  .style-number-ipad {
    margin-right: 0 !important;
  }

  .modal-content {
    width: 112%;
    margin-left: -28px;
    opacity: 0.9;
  }
  .modal-dialog {
    margin-top: 90%;
    width: 100%;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .class-mobile {
    display: flex !important;
    width: 100%;
    margin: 0 auto;
  }
  .class-desktop {
    display: none !important;
  }
  .style-number-ipad {
    padding-left: 30px !important ;
  }
  .style-time-ipad {
    margin-right: 23% !important;
  }

  .modal-dialog {
    margin-top: 7%;
    max-width: 550px;
  }
}

@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
  .modal-dialog {
    margin-top: 7%;
  }
}

@media only screen and (min-width: 2000px) {
  .modal-dialog {
    margin-top: 12%;
  }
  /* for sumo sized (mac) screens */
}
/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* For portrait layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/pix/PixCopy.vue